import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <header className="site-header">
     
      <div className="header-main">
        <div className="header-container">
          <Link to="/" className="logo-link" onClick={toTop}>
            <img
              className="brand-wordmark-image"
              src="/head/tunrisefield-wordmark.svg"
              alt="tunrisefield"
            />
          </Link>
          <nav className="main-nav">
            <Link to="/shop" onClick={toTop}>
              shop
            </Link>
            <span className="nav-separator"></span>
            <Link to="/about" onClick={toTop}>
              about
            </Link>
            <span className="nav-separator"></span>
            <Link to="/contact" onClick={toTop}>
              contact
            </Link>
            <span className="nav-separator"></span>
            <details className="more-menu">
              <summary>more</summary>
              <div className="more-menu-panel">
                <Link to="/faq" onClick={toTop}>faqs</Link>
                <Link to="/policies" onClick={toTop}>policy center</Link>
                <Link to="/privacy" onClick={toTop}>privacy policy</Link>
                <Link to="/terms" onClick={toTop}>terms of service</Link>
                <Link to="/shipping" onClick={toTop}>shipping</Link>
                <Link to="/returns" onClick={toTop}>refund policy</Link>
              </div>
            </details>
          </nav>
          <div className="header-actions">
            <Link
              to="/cartpage"
              className="action-btn cart-btn"
              aria-label="Cart"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                className="icon icon-cart-empty"
                viewBox="0 0 40 40"
                width={44}
                height={44}
              >
                <path
                  fill="currentColor"
                  fillRule="evenodd"
                  d="M15.75 11.8h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33L28.4 11.8zm0 1h-2.22l-.71 10.67a4 4 0 0 0 3.99 4.27h7.38a4 4 0 0 0 4-4.27l-.72-10.67h-2.22v.63a4.75 4.75 0 1 1-9.5 0zm8.5 0h-7.5v.63a3.75 3.75 0 1 0 7.5 0z"
                />
              </svg>

              {totalItems > 0 && (
                <span className="cart-count">{totalItems}</span>
              )}
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
